import { DEMO_CONFIG } from "./demo.config";

export interface DemoPlayer {
  id: string;
  username: string;
  currency: string;
  balance: number;
}

export const createDemoPlayer = (): DemoPlayer => ({
  id: "demo-player",
  username: "Demo Player",
  currency: DEMO_CONFIG.currency,
  balance: DEMO_CONFIG.initialDemoBalance,
});
